import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

const fetchClinicalHistory = async (fileId) => {
  const { data } = await axios.get(`${API_BASE_URL}/vcf/${fileId}/clinical-history`)
  return data
}

export const useClinicalHistory = ({ fileId }) => {
  // This can be used with React Query if needed
  return { query: { data: null } } // Simplified for now
}

export const getClinicalHistory = fetchClinicalHistory
